import { useEffect } from "react"

import { useTranslation } from "react-i18next"

import { useSelectedResort } from "@/hooks"
import { useResortParam } from "@/hooks/useSkipassFlow"

import { setLinkTag, setMetaTag, setTitleTag } from "./helpers"

// We use direct DOM manipulation instead of React 19's built-in <meta> hoisting
// because the appshell may already have tags in <head> (e.g. og:type, description).
// React 19 only manages tags it rendered itself — it would create duplicates
// instead of updating pre-existing appshell tags. The DOM approach lets us
// upsert existing tags and skip removal of ones we didn't create.
const MetaTags = () => {
  const { t } = useTranslation()
  const { selectedResort } = useSelectedResort()
  const { resortExternalId } = useResortParam()

  const resortName = selectedResort?.name

  useEffect(() => {
    if (!resortName) return

    const title = t("seo.title", { destination: resortName })
    const description = t("seo.description")
    const keywords = `SkiPass, ${resortName}`
    const canonical = `${window.location.origin}${window.location.pathname}`

    const cleanups = [
      setTitleTag(title),
      setLinkTag("canonical", canonical),
      setMetaTag("name", "description", description),
      setMetaTag("property", "og:description", description),
      setMetaTag("name", "twitter:description", description),
      setMetaTag("name", "keywords", keywords),
      setMetaTag("property", "og:title", title),
      setMetaTag("name", "twitter:title", title),
      setMetaTag("property", "og:type", "article"),
      setMetaTag("property", "og:url", canonical),
      setMetaTag("name", "robots", "noindex"),
    ]

    return () => {
      cleanups.forEach((cleanup) => cleanup())
    }
  }, [t, resortName, resortExternalId])

  return null
}

export default MetaTags
